var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.form
    ? _c(
        "form",
        {
          staticClass: "registration-form",
          attrs: { action: _vm.action, method: "POST" }
        },
        [
          _c("input", {
            attrs: { type: "hidden", name: "_token" },
            domProps: { value: _vm.csrkToken }
          }),
          _vm._v(" "),
          _c(
            "md-card",
            { staticClass: "profil-form" },
            [
              _c("md-card-header", [
                _c("h2", {
                  staticClass: "md-title md-title-dark page-sub-title",
                  domProps: { innerHTML: _vm._s(_vm.title) }
                })
              ]),
              _vm._v(" "),
              _c(
                "md-card-content",
                [
                  _c("transition", { attrs: { name: "slide-y-top" } }, [
                    _c("div", [
                      !_vm.hideEntityType
                        ? _c(
                            "div",
                            {
                              staticClass: "entity-type-container",
                              class: { "md-invalid": !!_vm.errors.entity_type }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.entityTypeSelectionLabel) + " : *"
                                )
                              ]),
                              _vm._v(" "),
                              _c("entity-type-input", {
                                attrs: { dusk: "entity-type-input" },
                                model: {
                                  value: _vm.fData.entity_type,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fData, "entity_type", $$v)
                                  },
                                  expression: "fData.entity_type"
                                }
                              }),
                              _vm._v(" "),
                              _vm.errors.entity_type
                                ? _c("span", { staticClass: "md-error" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.errors.entity_type
                                          ? _vm.errors.entity_type[0]
                                          : ""
                                      )
                                    )
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.fData.entity_type == "company"
                        ? _c(
                            "div",
                            { staticClass: "form-row" },
                            [
                              _c(
                                "md-field",
                                {
                                  class: {
                                    "md-invalid": !!_vm.errors.entity_name
                                  }
                                },
                                [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(_vm.$t("registration.entity-name"))
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("md-input", {
                                    attrs: {
                                      type: "text",
                                      name: "entity_name",
                                      disabled: _vm.submitting
                                        ? "disabled"
                                        : null,
                                      dusk: "entity-name-input",
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.fData.entity_name,
                                      callback: function($$v) {
                                        _vm.$set(_vm.fData, "entity_name", $$v)
                                      },
                                      expression: "fData.entity_name"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass: "md-error",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.errors.entity_name
                                          ? _vm.errors.entity_name[0]
                                          : ""
                                      )
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c(
                              "md-field",
                              {
                                class: { "md-invalid": !!_vm.errors.lastname }
                              },
                              [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(_vm.$t("registration.lastname"))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("md-input", {
                                  attrs: {
                                    name: "lastname",
                                    disabled: _vm.submitting
                                      ? "disabled"
                                      : null,
                                    required: ""
                                  },
                                  model: {
                                    value: _vm.fData.lastname,
                                    callback: function($$v) {
                                      _vm.$set(_vm.fData, "lastname", $$v)
                                    },
                                    expression: "fData.lastname"
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "md-error" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.lastname
                                        ? _vm.errors.lastname[0]
                                        : ""
                                    )
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c(
                              "md-field",
                              {
                                class: { "md-invalid": !!_vm.errors.firstname }
                              },
                              [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(_vm.$t("registration.firstname"))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("md-input", {
                                  attrs: {
                                    name: "firstname",
                                    disabled: _vm.submitting
                                      ? "disabled"
                                      : null,
                                    required: ""
                                  },
                                  model: {
                                    value: _vm.fData.firstname,
                                    callback: function($$v) {
                                      _vm.$set(_vm.fData, "firstname", $$v)
                                    },
                                    expression: "fData.firstname"
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "md-error" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.firstname
                                        ? _vm.errors.firstname[0]
                                        : ""
                                    )
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-row" },
                        [
                          _c("city-input", {
                            attrs: {
                              "no-icon": "",
                              name: "city_id",
                              label: _vm.$t("registration.your-city"),
                              "no-label": true,
                              "city-name": _vm.fData["city_name"],
                              "input-error": _vm.errors["city_id"],
                              disabled: _vm.submitting ? "disabled" : null,
                              dusk: "city-input",
                              required: ""
                            },
                            model: {
                              value: _vm.fData["city_id"],
                              callback: function($$v) {
                                _vm.$set(_vm.fData, "city_id", $$v)
                              },
                              expression: "fData['city_id']"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "form-row",
                          class: { "mt-35": !!_vm.errors.mobile }
                        },
                        [
                          _c("phone-field", {
                            ref: "phoneInput",
                            attrs: {
                              name: "phone",
                              errors: _vm.errors.mobile,
                              label: _vm.$t("registration.mobile"),
                              "mobile-only": "",
                              "country-id": _vm.countryId,
                              disabled: _vm.submitting ? "disabled" : null,
                              required: ""
                            },
                            model: {
                              value: _vm.fData.mobile,
                              callback: function($$v) {
                                _vm.$set(_vm.fData, "mobile", $$v)
                              },
                              expression: "fData.mobile"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.showEmailField
                        ? _c(
                            "div",
                            { staticClass: "form-row" },
                            [
                              _c(
                                "md-field",
                                { class: { "md-invalid": !!_vm.errors.email } },
                                [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(_vm.$t("registration.your-email"))
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("md-input", {
                                    attrs: {
                                      type: "email",
                                      name: "email",
                                      disabled: _vm.submitting
                                        ? "disabled"
                                        : null,
                                      dusk: "email-input",
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.fData.email,
                                      callback: function($$v) {
                                        _vm.$set(_vm.fData, "email", $$v)
                                      },
                                      expression: "fData.email"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass: "md-error",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.errors.email
                                          ? _vm.errors.email[0]
                                          : ""
                                      )
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-row" },
                        [
                          _c(
                            "md-field",
                            { class: { "md-invalid": !!_vm.errors.password } },
                            [
                              _c("label", [
                                _vm._v(_vm._s(_vm.$t("registration.password")))
                              ]),
                              _vm._v(" "),
                              _c("md-input", {
                                attrs: {
                                  type: "password",
                                  name: "password",
                                  disabled: _vm.submitting ? "disabled" : null,
                                  required: ""
                                },
                                on: {
                                  focus: function($event) {
                                    _vm.passwordFieldFocused = true
                                    _vm.passwordFieldTouched = true
                                  },
                                  blur: function($event) {
                                    _vm.passwordFieldFocused = false
                                  }
                                },
                                model: {
                                  value: _vm.fData.password,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fData, "password", $$v)
                                  },
                                  expression: "fData.password"
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "md-error" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errors.password
                                      ? _vm.errors.password[0]
                                      : ""
                                  )
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row form-row-submit" }, [
                        _c(
                          "div",
                          { staticClass: "form-submit-button" },
                          [
                            _c("p", {
                              staticClass: "accept-tos",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("registration.accept-tos")
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("submit-button", {
                              staticClass: "registration-standalone-button",
                              attrs: {
                                type: "submit",
                                submitting: _vm.submitting,
                                label: _vm.$t(
                                  "registration.confirm-email.button"
                                ),
                                dusk: "submit-profile-button"
                              },
                              on: {
                                click: function($event) {
                                  _vm.onSubmit()
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-row form-row-already-member" },
                        [
                          _c("a", { attrs: { href: "/member" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("registration.already-member-log-in")
                              )
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("hr", { staticClass: "pilot-owner-separator" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row pilot-owner-links" }, [
                        _c(
                          "a",
                          { attrs: { href: "/registration-other/pilot" } },
                          [_vm._v(_vm._s(_vm.$t("registration.you-are-pilot")))]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "pilot-owner-divider" }, [
                          _vm._v("|")
                        ]),
                        _vm._v(" "),
                        _c(
                          "a",
                          { attrs: { href: "/registration-other/owner" } },
                          [_vm._v(_vm._s(_vm.$t("registration.you-are-owner")))]
                        )
                      ])
                    ])
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-20e1b5aa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20e1b5aa","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/registration/Profile/formSimple.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-20e1b5aa","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/registration/Profile/formSimple.vue
// module chunks = 1 2 3